import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import MultiSelect from '../../../internal/MultiSelect'

import { getText } from '../../../internal/TextLabels'
import {
  getCountryName,
  getCountryNames,
} from '../../../internal/TextLabels/text'
import { getCountryIds } from '../../../models/countries'

const NewsFormCountry = ({
  newsCountries,
  onChange,
  fieldName,
  fieldCaption,
}) => {
  const [countryIds, setCountryIds] = useState(
    newsCountries && newsCountries.map(c => c.id.c),
  )
  useEffect(
    () => setCountryIds(newsCountries && newsCountries.map(c => c.id)),
    [newsCountries],
  )

  const onCountriesChanged = values => {
    const newSelectedCountries = values.map(id => ({
      id,
      name: getCountryName(id),
    }))
    setCountryIds(newSelectedCountries.map(c => c.id.c))
    onChange(values)
  }
  return (
    <MultiSelect
      fieldName={fieldName}
      fieldCaption={fieldCaption}
      values={getCountryIds()}
      defaultValues={countryIds}
      multiple
      names={getCountryNames()}
      addText={getText('news.add.recipientSection.addCountry')}
      onChange={onCountriesChanged}
      round
      hideButton
    />
  )
}

NewsFormCountry.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  newsCountries: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default NewsFormCountry
